import { IToastProps, Toast as BaseToast } from "native-base"
import { delay } from "../../utils/delay"

const ToastProxyHandler = {
  get(target, prop, receiver) {
    if (this[prop]) return this[prop];
    return Reflect.get(target, prop, receiver)
  },
  show(show: IToastProps) {
    if (show.id && BaseToast.isActive(show.id)) {
      BaseToast.close(show.id)
      delay(1000).then(() => BaseToast.show(show))
    } else {
      BaseToast.show(show)
    }
  }
}

export const Toast = new Proxy(BaseToast, ToastProxyHandler)
